import Tag from './Tag';
/**
 * @deprecated Please start using Tag component
 */

var RemovableTag = Tag;
RemovableTag.displayName = 'RemovableTag';
export default RemovableTag;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/tag/dist/esm/variants/RemovableTag.js
// module id = 4060
// module chunks = 11